import React from 'react';

/**
 * Navigation tile primitives. Mirrors the prototype's `.nav-tiles` / `.nav-tiles-4`
 * / `.nav-tile` / `.nav-icon` / `.nav-copy` / `.nav-title` / `.nav-sub` / `.nav-arrow`.
 *
 * IMPORTANT: the prototype positions icons via :nth-child on direct children, so
 * <NavTile> children must be the only direct DOM children of <NavTiles>.
 *
 *  <NavTiles count={4}>
 *      <NavTile icon={<svg .../>} title="Campaigns" sub="3 active" />
 *      <NavTile icon={<svg .../>} title="Education" />
 *  </NavTiles>
 */
export const NavTiles = ({count, children, className = '', ...rest}) => {
    const cn = count === 4 ? 'nav-tiles nav-tiles-4' : 'nav-tiles';
    const finalCn = [cn, className].filter(Boolean).join(' ');
    return (
        <div className={finalCn} {...rest}>
            {children}
        </div>
    );
};

export const NavTile = ({icon, title, sub, onClick, className = '', ...rest}) => {
    const cn = ['nav-tile', className].filter(Boolean).join(' ');
    return (
        <div
            className={cn}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            {...rest}
        >
            <div className="nav-icon">{icon}</div>
            <div className="nav-copy">
                <div className="nav-title">{title}</div>
                {sub && <div className="nav-sub">{sub}</div>}
            </div>
            <div className="nav-arrow">→</div>
        </div>
    );
};
